import { useTranslation } from 'react-i18next';
import StandardModal, { ModalButtonType, ModalSize } from '../../Fundamentals/Modal/StandardModal';
import dateUtils from '../../../Utils/dateUtils';
import type { PackageScheduledChange } from './Packages.types';

interface CancelScheduledChangeModalProps {
    change: PackageScheduledChange;
    isLoading: boolean;
    onConfirm: () => void;
}

// cancelling keeps the row (as Cancelled), so the buttons say so instead of "Delete"
const CancelScheduledChangeModal = ({ change, isLoading, onConfirm }: CancelScheduledChangeModalProps) => {
    const { t } = useTranslation();

    return (
        <StandardModal
            title={t('packages.cancelScheduledChange')}
            size={ModalSize.SMALL}
            type={ModalButtonType.DELETE}
            isLoading={isLoading}
            submitLabel={t('packages.cancelScheduledChangeConfirm') ?? ''}
            cancelLabel={t('packages.keepScheduledChange') ?? ''}
            onSubmit={onConfirm}
        >
            <p className="mb-0">{t('packages.cancelScheduledChangeText', { date: dateUtils.formatDateOrPlaceholder(change.scheduledDate, '—') })}</p>
        </StandardModal>
    );
};

export default CancelScheduledChangeModal;
